export const translatedTimerLabels = {
    en: {
        countdown: 'Countdown',
        days: 'Days',
        hours: 'Hours',
        minutes: 'Minutes',
        seconds: 'Seconds'
    },
    pt: {
        countdown: 'Contagem Regressiva',
        days: 'Dias',
        hours: 'Horas',
        minutes: 'Minutos',
        seconds: 'Segundos'
    },
    es: {
        countdown: 'Cuenta Regresiva',
        days: 'Días',
        hours: 'Horas',
        minutes: 'Minutos',
        seconds: 'Segundos'
    },
    fr: {
        countdown: 'Compte à Rebours',
        days: 'Jours',
        hours: 'Heures',
        minutes: 'Minutes',
        seconds: 'Secondes'
    },
    de: {
        countdown: 'Countdown',
        days: 'Tage',
        hours: 'Stunden',
        minutes: 'Minuten',
        seconds: 'Sekunden'
    },
    it: {
        countdown: 'Conto alla Rovescia',
        days: 'Giorni',
        hours: 'Ore',
        minutes: 'Minuti',
        seconds: 'Secondi'
    },
    ru: {
        countdown: 'Обратный отсчёт',
        days: 'Дни',
        hours: 'Часы',
        minutes: 'Минуты',
        seconds: 'Секунды'
    },
    zh: {
        countdown: '倒计时',
        days: '天',
        hours: '小时',
        minutes: '分钟',
        seconds: '秒'
    },
    ja: {
        countdown: 'カウントダウン',
        days: '日',
        hours: '時間',
        minutes: '分',
        seconds: '秒'
    },
    ko: {
        countdown: '카운트다운',
        days: '일',
        hours: '시간',
        minutes: '분',
        seconds: '초'
    },
    hi: {
        countdown: 'काउंटडाउन',
        days: 'दिन',
        hours: 'घंटे',
        minutes: 'मिनट',
        seconds: 'सेकंड'
    },
    ar: {
        countdown: 'العد التنازلي',
        days: 'أيام',
        hours: 'ساعات',
        minutes: 'دقائق',
        seconds: 'ثواني'
    },
    tr: {
        countdown: 'Geri Sayım',
        days: 'Gün',
        hours: 'Saat',
        minutes: 'Dakika',
        seconds: 'Saniye'
    },
    nl: {
        countdown: 'Aftellen',
        days: 'Dagen',
        hours: 'Uren',
        minutes: 'Minuten',
        seconds: 'Seconden'
    },
    sv: {
        countdown: 'Nedräkning',
        days: 'Dagar',
        hours: 'Timmar',
        minutes: 'Minuter',
        seconds: 'Sekunder'
    },
    no: {
        countdown: 'Nedtelling',
        days: 'Dager',
        hours: 'Timer',
        minutes: 'Minutter',
        seconds: 'Sekunder'
    },
    pl: {
        countdown: 'Odliczanie',
        days: 'Dni',
        hours: 'Godziny',
        minutes: 'Minuty',
        seconds: 'Sekundy'
    },
    he: {
        countdown: 'ספירה לאחור',
        days: 'ימים',
        hours: 'שעות',
        minutes: 'דקות',
        seconds: 'שניות'
    },
    fi: {
        countdown: 'Lähtölaskenta',
        days: 'Päivät',
        hours: 'Tunnit',
        minutes: 'Minuutit',
        seconds: 'Sekunnit'
    },
    el: {
        countdown: 'Αντίστροφη Μέτρηση',
        days: 'Ημέρες',
        hours: 'Ώρες',
        minutes: 'Λεπτά',
        seconds: 'Δευτερόλεπτα'
    },
    da: {
        countdown: 'Nedtælling',
        days: 'Dage',
        hours: 'Timer',
        minutes: 'Minutter',
        seconds: 'Sekunder'
    }
};
